module.exports = __webpack_public_path__ + "static/media/gallery_02.190f8f4d.png";